import ArtistPieceRecords from "./ArtistPieceRecords";

export default ArtistPieceRecords;
